// Mapeo etiqueta de negocio -> ID de product_tag en WooCommerce
export const ETIQUETAS_WOO = {
  "Apartada": 624,
  "Nuevo Ingreso": 623,
  "Promoción": 1507,
  "Vendida": 625,
};

// En caso de necesitar slugs también:
export const ETIQUETAS_SLUG = {
  "Apartada": "etiqueta_apartada",
  "Nuevo Ingreso": "nuevo_ingreso",
  "Promoción": "etiqueta_promocion",
  "Vendida": "etiqueta_vendida",
};